module.exports = __webpack_public_path__ + "static/media/icon-linkedin.21040fea.svg";